













































































































































































/** @format */
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import OrganizationSearch from '@/components/organization-search/index.vue';
import { nonnegativeInteger, positiveInteger } from '@root/utils/validators';
// axios请求
import {
  chargingPileCreate,
  chargingPileEdit,
  chargingList,
  chargingPileBrand
} from '@/api/chargingpile-management/index';
import ParkingLotSearch from '@/components/parking-lot-search/index.vue';
import Utils from '@root/utils/common';
// 字典
import { chargingpileStatusMap, allowCumsumMap, allowTypeMap } from '@/types/chargingpile-management/dictionaries';
export interface IForm {
  brandName: string;
  orgdepId: string;
  miniChargedTime: string;
  discountTime: string;
  allowCumsum: string;
  discountLimit: string;
  brandId: string; //	品牌ID
  parkId: any; //	车场id
  ruleName: string; //	优惠名称
  discountType: string; //	优惠类型
  discountValue: string; //
}
@Component({
  name: 'AddEdit',
  components: { OrganizationSearch, ParkingLotSearch }
})
export default class AddEdit extends Vue {
  // 是否编辑状态
  @Prop({ type: Boolean, default: false })
  isEdit!: boolean;
  // 是否展示弹窗
  @Prop({ type: Boolean, default: false })
  visible!: boolean;
  // 编辑状态回填数据
  @Prop()
  data!: any;
  form: any = null;
  labelCol = { span: 7 };
  wrapperCol = { span: 15 };
  validatorsValue = nonnegativeInteger;
  positiveInteger = positiveInteger;
  pkBrandRuleId = '';
  confirmLoading: boolean = false;
  discountTypeOptions: IOption[] = Utils.toLabelVal(allowTypeMap);
  brandList: any[] = [];
  //form初始化
  init() {
    if (this.isEdit && this.data) {
      this.form = this.$form.createForm(this, {
        mapPropsToFields: () => {
          let {
            brandId,
            brandName,
            orgdepId,
            miniChargedTime,
            discountTime,
            allowCumsum,
            discountLimit,
            parkId, //	车场id
            ruleName, //	优惠名称
            discountType, //	优惠类型
            discountValue,
            discountName,
            brandRuleId
          } = this.data;
          console.log(discountLimit, 'lai   le --------------->>>>>');
          if (discountLimit === '999') {
            discountLimit = 0;
          }
          this.pkBrandRuleId = brandRuleId;
          this.changeVlue = discountType;
          return {
            brandId: this.$form.createFormField({
              value: brandId
            }),
            brandName: this.$form.createFormField({
              value: brandName
            }),
            orgdepId: this.$form.createFormField({
              value: orgdepId
            }),
            miniChargedTime: this.$form.createFormField({
              value: miniChargedTime
            }),
            discountTime: this.$form.createFormField({
              value: discountTime
            }),
            allowCumsum: this.$form.createFormField({
              value: allowCumsum
            }),
            discountLimit: this.$form.createFormField({
              value: discountLimit
            }),
            parkId: this.$form.createFormField({
              value: parkId.split(',') || []
            }),
            ruleName: this.$form.createFormField({
              value: discountName
            }),
            discountType: this.$form.createFormField({
              value: discountType
            }),
            discountValue: this.$form.createFormField({
              value: discountValue
            })
          };
        }
      });
    } else {
      this.pkBrandRuleId = '';
      this.form = this.$form.createForm(this, {
        mapPropsToFields: () => {
          return {
            allowCumsum: this.$form.createFormField({
              value: '01'
            })
          };
        }
      });
    }
  }

  activated() {
    // console.log('000,wo lai le ');
    this.getChargingList();
  }
  //获取充电品牌列表
  async getChargingList() {
    try {
      const res = await chargingPileBrand({});
      this.brandList = res.data.map(item => {
        return { label: item.brandName, value: item.pkChargeBrandId };
      });
      // this.filterParam.brandId = ''
    } catch (e) {
      this.$message.error((e && e.msg) || '系统异常请稍后再试');
    }
  }
  //提交表单
  async onSubmit() {
    this.form.validateFields(async (err: boolean, values: IForm) => {
      if (!err) {
        if (this.confirmLoading) return;
        this.confirmLoading = true;
        if (this.isEdit) {
          this.editForm(values);
        } else {
          this.addForm(values);
        }
      }
    });
  }
  changeVlue = '';
  handTypediscountChange(val) {
    this.changeVlue = val;
  }
  //新增
  async addForm(values: IForm) {
    try {
      await chargingPileCreate({ ...values, parkId: values.parkId.join(',') });
      this.successTip();
    } catch (e) {
      this.$message.error((e && e.msg) || '新增失败');
    } finally {
      this.confirmLoading = false;
    }
  }
  //编辑
  async editForm(values: IForm) {
    try {
      await chargingPileEdit({ ...values, pkBrandRuleId: this.pkBrandRuleId, parkId: values.parkId.join(',') });
      this.successTip();
    } catch (e) {
      this.$message.error((e && e.msg) || '编辑失败');
    } finally {
      this.confirmLoading = false;
    }
  }
  //成功提示
  successTip() {
    this.$message.success(`${this.isEdit ? '编辑' : '新增'}成功`);
    this.form.resetFields();
    this.$emit('create');
  }
  //取消
  cancelForm() {
    this.form.resetFields();
    this.$emit('cancel');
    this.confirmLoading = false;
  }
  @Watch('visible')
  visibleChanged(val: boolean) {
    if (val) {
      this.init();
    }
  }

  mounted() {
    this.init();
    this.getChargingList();
  }
  filterOption(input, option) {
    return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
  }
}
